import React, { Fragment } from 'react';
import VehiclePhoto from '../formSection/Fields/VehiclePhoto';
import { UPLOAD_VEHICLE_PHOTOS } from '../../../api/constants';

const Section10 = ({ disabled, form, vehicleId }) => {
    const photos = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(index => ({ value: form.getFieldValue('photo' + index), index })).sort();
    return (
        <Fragment>
            <div className="border-emmit" />
            <div className="aHeight-3" />
            <div className="wrapTenPhoto">
                <span className="label">
                    Фотографии ТС
                    <br />
                    (до 10 штук):
                </span>
                <div className="photos">
                    {photos.sort((a, b) => {
                        if (a.value) {
                            return -1
                        } else if (b.value) {
                            return +1
                        } else {
                            return 0
                        }
                    }).map((item, index) => {
                        if (index === photos.length - 1 || item.value) {
                            return (
                                <VehiclePhoto
                                    key={item.index}
                                    form={form}
                                    disabled={disabled}
                                    name={`photo${item.index}`}
                                    data={{ vehicle_id: vehicleId, photo_number: item.index, image_url: item.value }}
                                    action={vehicleId && vehicleId > 0 ? UPLOAD_VEHICLE_PHOTOS : null}
                                />
                            )
                        } else {
                            return null
                        }
                    }
                    )}
                </div>
            </div>
            <div className="aHeight-3" />
            <div className="aHeight-3" />
        </Fragment>
    );
};

export default Section10;
